import { Skeleton } from "../../Skeleton";
import { cn } from "../../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TableText = function TableText(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-line-clamp-2 tw-font-link1 tw-text-neutral-light-800 dark:tw-text-neutral-light-100",
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      className: "tw-line-clamp-1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400",
      children: subtitle
    })]
  });
};
export var TableTextSkeleton = function TableTextSkeleton(_ref2) {
  var subtitle = _ref2.subtitle,
    className = _ref2.className;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-gap-0.8",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      className: cn('tw-h-1.6 tw-w-16 tw-rounded-[4.8rem]', className)
    }), subtitle && /*#__PURE__*/_jsx(Skeleton, {
      className: cn('tw-h-1.6 tw-w-3/5 tw-rounded-[4.8rem]')
    })]
  });
};